import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Table, Tooltip, Badge } from "../../components/ui";
import { formatToLocalDate } from "utils";

const RefundTooltip = ({ amount, index }) => {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => {
    setOpen(!open);
  }, [open]);

  return (
    <>
      <Badge
        pill
        id={`bl-refund-tooltip-${index}`}
        theme="info"
        className="ml-3"
      >
        Refunded
      </Badge>
      <Tooltip
        open={open}
        target={`#bl-refund-tooltip-${index}`}
        toggle={toggle}
      >
        <span className="black" style={{ fontSize: "14px" }}>
          {amount} refunded
        </span>
      </Tooltip>
    </>
  );
};

const SimpleTable = ({ tableContent, tableHeadings }) => {
  const renderTableHeader = () => {
    return tableHeadings.map((key, index) => {
      return <th key={index}>{key}</th>;
    });
  };

  const paymentMethod = (id) => {
    if (id === 1) {
      return "Credit Card";
    }
    if (id === 2) {
      return "Bitcoin";
    }
    if (id === 3) {
      return "Complimentary";
    }
    if (id === 4) {
      return "Manual";
    }
    if (id === 5) {
      return "NFT";
    }
  };

  const handleDateFormatting = (date) => {
    return formatToLocalDate(date);
  };

  const renderTableData = () => {
    return tableContent.map((data, index) => {
      const { product, amount, date, paymentMethodId, refundedAmount } = data; //destructuring
      return (
        <tr key={index}>
          <td>{product.name}</td>
          <td
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span>{amount}</span>
            {refundedAmount ? (
              <RefundTooltip amount={refundedAmount} index={index} />
            ) : null}
          </td>
          <td>{paymentMethod(paymentMethodId)}</td>
          <td>{handleDateFormatting(date)}</td>
        </tr>
      );
    });
  };

  return (
    <Table className="simple-table" responsive>
      <thead>
        <tr className="table-head">{renderTableHeader()}</tr>
      </thead>
      <tbody>{renderTableData()}</tbody>
    </Table>
  );
};

SimpleTable.propTypes = {
  tableContent: PropTypes.array,
  tableHeadings: PropTypes.array,
};

export default SimpleTable;
